import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/link/base"

const link = {
  linkList(pageSize, limit, name) {
    return axios.get(pre + `/linkList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          name: name,
        }
    });
  },
  appraisalList(pageSize, limit, name) {
    return axios.get(pre + `/appraisalList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          name: name,
        }
    });
  },
  appraisalSortList(pageSize, limit) {
    return axios.get(pre + `/appraisalSortList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit
        }
    });
  },
  getLinkInfo(id) {
    return axios.get(pre + `/getLinkInfo`, {params: {id: id}});
  },
  saveLink(params) {
    return axios.post(pre + `/saveLink`, qs.stringify(params));
  },
  deleteLink(id) {
    return axios.post(pre + `/deleteLink`, qs.stringify({id: id}));
  },
}
export default link;



// WEBPACK FOOTER //
// ./src/api/config/linkConfig.js